import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/material";

function InputComponent(props) {
  const {
    label,
    value,
    onChange,
    width,
    fullWidth,
    errorText,
    validate,
    backgroundColor,
    fontSize = "15px",
    textColor = "white",
     disabled = false  
  } = props;
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    if (validate) {
      const error = validate(value);
      setValidationError(error || "");
    }
  }, [value, validate]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setValidationError("");

   if (onChange && !disabled) { 
      onChange(inputValue);
    }
  };

  return (
    <Stack>
      <label
        style={{
          marginBottom: "4px",
          color: textColor,
          fontSize: fontSize,
          fontFamily: "Raleway, sans-serif",
          fontWeight: 500,
        }}
      >
        {label}
      </label>
      <Stack sx={{ borderRadius: "8px", backgroundColor: backgroundColor }}>
        <TextField
          value={value}
          onChange={handleInputChange}
          fullWidth={fullWidth}
          sx={{
            width: width,
            fontFamily: "Raleway, sans-serif",
            "& .MuiOutlinedInput-root": {
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              borderRadius: "4px", // Bordes redondeados
              backgroundColor: backgroundColor, // Fondo del contenedor principal
              fontFamily: "Raleway, sans-serif",
              fontWeight: 400,
              "&:hover": {
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
              },
              "&.Mui-focused": {
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
              },
              "& fieldset": {
                borderRadius: "4px", // Bordes redondeados del fieldset
                border: "none", // Eliminar el borde
              },
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "4px", // Bordes redondeados del notchedOutline
              border: "none",
              fontFamily: "Raleway, sans-serif",
            },
            "& .MuiInputBase-input": {
              fontSize: fontSize, // Tamaño de la fuente
              color: textColor, // Color de la letra
              padding: "8px",
              paddingBottom: "4px", // Ajustar padding interno
              minHeight: "auto",
              fontFamily: "Raleway, sans-serif",
              fontWeight: 400,
            },
          }}
          variant="outlined"
          error={!!validationError || !!errorText}
        />
      </Stack>
    </Stack>
  );
}

export default InputComponent;
